"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var tooltip_style_1 = require("./tooltip-style");
var tooltip_type_1 = require("./tooltip-type");
function Tooltip(props) {
    var id = props.id, _a = props.mode, mode = _a === void 0 ? tooltip_type_1.TooltipMode.LIGHT : _a, children = props.children, restProps = __rest(props, ["id", "mode", "children"]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(children.type, __assign({}, children.props, { "data-tooltip-id": id })), (0, jsx_runtime_1.jsx)(tooltip_style_1.StyledTooltip, __assign({}, restProps, { id: id, mode: mode, classNameArrow: "hello-arrow" }))] }));
}
exports.Tooltip = Tooltip;
